<svg viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="24" height="24" />
</svg>
